import { call, take, put } from 'redux-saga/effects';
import { get, putMethod } from '../../utils/api';
import settings from '../../utils/settings';

import {
  THIRD_PARTY_REQUEST,
  THIRD_PARTY_SUCCESS,
  THIRD_PARTY_UPDATE_REQUEST,
  THIRD_PARTY_UPDATE_SUCCESS,
  REQUEST_FAILURE
} from './constants';

export function* getThirdPartList() {
  while (true) {
    yield take(THIRD_PARTY_REQUEST);
    try {
      let response;
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/third-parties`)
      });
      if (response.success) {
        yield put({ type: THIRD_PARTY_SUCCESS, thirdPartyList: response.result });
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: getThirdPartList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}

export function* updateThirdPartList() {
  while (true) {
    const request = yield take(THIRD_PARTY_UPDATE_REQUEST);
    try {
      let response;
      const { party, status, onSuccesCbk, isFrom = 'clearState' } = request.payload;
      response = yield call(putMethod, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/account/third-parties/update`),
        body: { party, status }
      });
      if (response.success) {
        if (isFrom === 'register') {
          yield put({ type: THIRD_PARTY_UPDATE_SUCCESS, navigationURL: response.result });
        } else {
          yield put({ type: THIRD_PARTY_UPDATE_SUCCESS, navigationURL: '' });
        }
        onSuccesCbk();
      } else {
        yield put({ type: REQUEST_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: updateThirdPartList:', error);
      yield put({ type: REQUEST_FAILURE, error: error });
    }
  }
}
